const getGamesExpiry = (games) => {
  if (games?.length > 0) {
    const expiries = games.map((g) => getSingleGameCacheExpiry(g));
    return Math.min(...expiries);
  }
  // no games - cache 1 h
  return 60 * 60 * 1000;
};

export const getCacheExpiryForGames = (response) => {
  const games = response?.games?.items ? response?.games?.items : response;
  return getGamesExpiry(games);
};

export const getCacheExpiryForStages = (response) => {
  const games = response?.length > 0 ? response.flatMap((s) => s?.games?.items) : response;
  const gamesExpiry = getCacheExpiryForGames(games);
  return Math.min(gamesExpiry, 2 * 60 * 60 * 1000);
};

export const getCacheExpiryForTeam = (response) => {
  if (!response) return 0;
  const games = response?.futureGames ? JSON.parse(response.futureGames) : undefined;
  const expiry = getGamesExpiry(games);

  return Math.min(expiry, 2 * 60 * 60 * 1000);
};

export const getSingleGameCacheExpiry = (game) => {
  switch (game.status) {
    case "COMPLETED":
      return 24 * 60 * 60 * 1000;
    case "HALFTIME": {
      return 2 * 60 * 1000;
    }
    case "IN_PROGRESS": {
      return 1 * 60 * 1000;
    }
    case "NOT_STARTED": {
      const exp = game.timestamp * 1000 - Date.now();
      return exp > 60 * 60 * 1000 ? exp - 60 * 60 * 1000 : 2 * 60 * 1000;
    }
    case "SUSPENDED":
    case "POSTPONED":
      return 5 * 60 * 1000;
    default:
      return 2 * 60 * 1000;
  }
};
